import React, { useEffect, useState } from 'react'
import './footer.css'
import footerlogo from '../../../assets/images/Royal77701.png'
import fb from '../../../assets/images/FaceBook.png'
import insta from '../../../assets/images/Insta.png'
import tele from '../../../assets/images/telegram.png'
import twitter from '../../../assets/images/twitter.png'
import Container from '../Container'
import { Link, useLocation } from 'react-router-dom'
import config from '../../../config'

function Footer() {
  const [show, setShow] = useState(false);
  const location = useLocation();
  const [domainName, setDomainName] = useState('');
  const [socialData, setSocialData] = useState({});
  const [dynamicWidth, setDynamicWidth] = useState('160px');

  useEffect(() => {
    let socialLinkObject = JSON.parse(localStorage.getItem('socialLinkObject'))
    setSocialData(socialLinkObject || {});

      const screenWidth = window.innerWidth;
      let data = localStorage.getItem('logoData')
      let datas = JSON.parse(data)
      if(datas !== null){
        if (screenWidth <= 767) {
          setDynamicWidth(`${datas.SM}px`);
        } else if (screenWidth <= 999) {
          setDynamicWidth(`${datas.MD}px`);
        } else if (screenWidth <= 1150) {
          setDynamicWidth(`${datas.LG}px`);
        } else {
          setDynamicWidth(`${datas.XL}px`);
        }
      }
    }, [dynamicWidth ]);

  useEffect(() => {
    const hostname = window.location.hostname;
    setDomainName(hostname);
    if(location.pathname==='/'){
      setShow(true)
    }
    return () => {
      setShow(false)
    }
  }, [location.pathname])


  return (
    <>
    {show && (
    <footer className='footer'>
        <Container size='full'>
        <div className='footer-row'>
        <div className='footer-logo'> <Link to='/'><img style={{ maxWidth: dynamicWidth }} loading="lazy" src={config.logoDetails.logo2} alt={''} decoding="async" fetchpriority="low"/> </Link> </div>
        {JSON.parse(localStorage.getItem("isB2c") || "false") ? 
        <div className='footer-content'>
        <p>This website is owned and operated by its respective entity. It has passed all regulatory compliance and is legally authorized to offer games of chance and wagering activities. All operations are conducted under strict guidelines to ensure fairness, transparency, and responsible gaming.</p>
        </div>:"" }
        {JSON.parse(localStorage.getItem("isB2c") || "false") ? 
        <div className='footer-links'>
          <div className='link'><Link to={socialData.FaceBook}><img className='social-icon' src={fb} alt='fb' decoding="async" loading="lazy"/></Link></div>
          <div className='link'><Link to={socialData.Insta}><img className='social-icon' src={insta} alt='insta' decoding="async" loading="lazy"/></Link></div>
          <div className='link'><Link to={socialData.telegram}><img className='social-icon' src={tele} alt='tele' decoding="async" loading="lazy"/></Link></div>
          <div className='link'><Link to={socialData.x}><img className='social-icon' src={twitter} alt='x' decoding="async" loading="lazy"/></Link></div>
        </div>
        :""}
        </div>
        </Container>
    </footer>
    )}
    </>
  )
}

export default Footer